import type { JSX } from 'react'
import Badge from '../../uiV2/common/badge/Badge'
import { BadgeColor } from '../../uiV2/common/badge/badgeTypes'
import {
    PersonNetworkImportLogStatusValue,
    PersonNetworkImportStatusValue,
} from '../../api/person/PersonApi'

const NETWORK_IMPORT_STATUS_BADGE_COLORS: Record<
    PersonNetworkImportStatusValue,
    BadgeColor
> = {
    EXCLUDED: BadgeColor.Neutral,
    IN_PROGRESS: BadgeColor.Progress,
    COMPLETE: BadgeColor.Success,
    FAILED: BadgeColor.Error,
    CACHE_INVALID: BadgeColor.Warning,
}

const NETWORK_IMPORT_LOG_STATUS_BADGE_COLORS: Record<
    PersonNetworkImportLogStatusValue,
    BadgeColor
> = {
    DISPATCH_PENDING: BadgeColor.Neutral,
    QUEUED: BadgeColor.InfoBlue,
    STARTED: BadgeColor.Cyan,
    IMPORT_IN_PROGRESS: BadgeColor.Progress,
    IMPORT_COMPLETE: BadgeColor.Success,
    NETWORK_GEN_IN_PROGRESS: BadgeColor.Progress,
    COMPLETE: BadgeColor.Success2,
    FAILED: BadgeColor.Error,
}

type BadgeBaseProps = {
    className?: string
    title?: string
}

type PersonNetworkImportStatusBadgeProps = BadgeBaseProps & {
    status: PersonNetworkImportStatusValue
}

export function PersonNetworkImportStatusBadge({
    status,
    className,
    title,
}: PersonNetworkImportStatusBadgeProps): JSX.Element {
    return (
        <Badge
            color={NETWORK_IMPORT_STATUS_BADGE_COLORS[status]}
            className={className}
            title={title}
        >
            {status}
        </Badge>
    )
}

type PersonNetworkImportLogStatusBadgeProps = BadgeBaseProps & {
    status: PersonNetworkImportLogStatusValue
}

export function PersonNetworkImportLogStatusBadge({
    status,
    className,
    title,
}: PersonNetworkImportLogStatusBadgeProps): JSX.Element {
    return (
        <Badge
            color={NETWORK_IMPORT_LOG_STATUS_BADGE_COLORS[status]}
            className={className}
            title={title}
        >
            {status}
        </Badge>
    )
}
